import type { WavespeedModelConfig } from '../types';

export const wavespeedToolConfigs: Record<string, WavespeedModelConfig> = {
    // 视频 AI 去水印
    'wavespeed-ai/video-watermark-remover': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/video-watermark-remover
        apiPath: '/wavespeed-ai/video-watermark-remover',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { videoUri } = params;
            return {
                // 视频 URL
                video: videoUri,
            };
        },
    },
};